import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function facilityFunc() {
  // root は外ラッパー、container が中の .swiper 本体
  const root = document.querySelector('.js-facility');
  if (!root) return;

  const container = root.querySelector('.swiper');
  if (!container) return;

  const mql = window.matchMedia('(max-width: 768px)');
  let swiper = null;

  const mount = () => {
    if (swiper || !mql.matches) return;

    const paginationEl = root.querySelector('.swiper-pagination');

    swiper = new Swiper(container, {
      modules: [Navigation, Pagination],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 12,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      navigation: {
        nextEl: root.querySelector('.swiper-button-next'),
        prevEl: root.querySelector('.swiper-button-prev'),
      },
      ...(paginationEl
        ? { pagination: { el: paginationEl, clickable: true } }
        : {}),
    });
  };

  const unmount = () => {
    if (!swiper) return;
    swiper.destroy(true, false); // クラスを残してPC静止レイアウト維持
    swiper = null;
  };

  const sync = () => (mql.matches ? mount() : unmount());

  // 初回 & 画面幅変更で切り替え
  sync();
  if (mql.addEventListener) mql.addEventListener('change', sync);
  else mql.addListener(sync);

  // 画像読み込み後にサイズ再計算（<picture>対策）
  window.addEventListener('load', () => {
    if (mql.matches && swiper) swiper.update();
  });
}
